import { combineReducers } from 'redux';

import { doraAnalyticsReducer } from '../analytics/store/reducer';
import { doraDataManagementReducer } from '../data-management/store/reducer';
import { doraFunctionReducer } from '../functions/store/reducer';
import { doraMyCompaniesReducer } from '../my-companies/store/reducer';
import { doraReportingReducer } from '../reporting/store/reducer';
import { doraSupplyChainReducer } from '../supply-chain/store/reducer';
import { doraThirdPartyReducer } from '../third-party-companies/store/reducer';

export const doraReducer = combineReducers({
    dataManagement: doraDataManagementReducer,
    functions: doraFunctionReducer,
    myCompanies: doraMyCompaniesReducer,
    thirdParty: doraThirdPartyReducer,
    supplyChain: doraSupplyChainReducer,
    analytics: doraAnalyticsReducer,
    reporting: doraReportingReducer
});
